import { useInfiniteQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getAdminSettlements } from 'services/fund/settlement'

export default function useGetAdminSettlements() {
    const { moneyPool } = useParams()
    // Keyed by fund, and NOT the key the member-side list uses: both hooks
    // said ['settlements-listss'], so whichever list opened second was handed
    // the other one's cached rows — two different shapes, and the admin list
    // reads `requesting_user.member.first_name` on rows that have no such
    // object.
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['admin-settlements', moneyPool],
        ({ pageParam = 1, queryKey }) =>
            getAdminSettlements(pageParam, moneyPool),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        settlements: data,
        isLoadingSettlements: isLoading,
        fetchNextPage,
        refetch,
    }
}
